/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const FieldType = {
    Text: 'Text',
    Number: 'Number',
    Checkbox: 'Checkbox',
    Option: 'Option',
    Search: 'Search',
    Phone: 'Phone',
    Date: 'Date',
    DateTime: 'DateTime'
} as const;
export type FieldType = typeof FieldType[keyof typeof FieldType];


export function FieldTypeFromJSON(json: any): FieldType {
    return FieldTypeFromJSONTyped(json, false);
}

export function FieldTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FieldType {
    return json as FieldType;
}

export function FieldTypeToJSON(value?: FieldType | null): any {
    return value as any;
}

